import React from 'react';

const features = [
  {
    title: 'Instant Delivery',
    desc: 'Airtime lands on your loved one’s phone within seconds of your payment going through — no delays.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
      </svg>
    ),
  },
  {
    title: 'All Major Networks',
    desc: 'Top up any major mobile network in Ethiopia, Kenya, Ghana and Nigeria, with more countries on the way.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20" />
        <path d="M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z" />
      </svg>
    ),
  },
  {
    title: 'Secure Card Payments',
    desc: 'Pay with Visa, Mastercard or any debit or credit card. Every transaction is encrypted and protected.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2 4 5v6c0 5 3.4 9 8 11 4.6-2 8-6 8-11V5l-8-3z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
  },
  {
    title: 'Great Airtime Rates',
    desc: 'Competitive rates with no hidden fees, so more of what you send actually reaches your family.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M9.5 9.5a2.5 2.5 0 1 1 3.7 2.2c-1.2.7-1.7 1.3-1.7 2.3" />
        <path d="M12 17h.01" />
      </svg>
    ),
  },
  {
    title: 'Recurring Top-Ups',
    desc: 'Schedule weekly or monthly airtime for a loved one once, and Smile Africa takes care of the rest.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 2v6h-6" />
        <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
        <path d="M3 22v-6h6" />
        <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      </svg>
    ),
  },
  {
    title: 'Purchase History',
    desc: 'Every top-up is saved in your history, so you can track exactly what you sent and when.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18" />
        <path d="m7 14 4-4 3 3 5-6" />
      </svg>
    ),
  },
];

const Features: React.FC = () => {
  return (
    <section className="min-h-screen bg-white flex items-center py-24">
      <div className="w-full px-[6vw]">

        {/* Header */}
        <div className="text-center mb-20">
          <h2
            className="font-bold text-gray-900 mb-4"
            style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4rem)' }}
          >
            Built for Buying Airtime
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Everything you need to keep loved ones connected, in one simple app.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-20">
          {features.map((feature, i) => (
            <div key={i} className="relative flex flex-col items-center text-center group rounded-2xl p-6 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:bg-orange-50 cursor-default">
              {/* Icon */}
              <div className="mb-6 w-14 h-14 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110" style={{ background: '#fff4ed' }}>
                {feature.icon}
              </div>
              {/* Title */}
              <h3
                className="font-bold text-gray-900 mb-4"
                style={{ fontSize: 'clamp(1.2rem, 2vw, 1.6rem)' }}
              >
                {feature.title}
              </h3>
              {/* Description */}
              <p className="text-gray-500 text-base leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Features;
